import {
  ACCESS,
  ACCESS_SECURITY,
  SERVICE,
  SET_STATUSES_LOADING,
  SET_STATUSES,
  NOTIFICATION,
  INCIDENT,
  CHANGE,
} from '../action-constants';

const initialState = {
  isLoading: false,
  access: {
    submitted: null,
    accepted: null,
    customerApprovalRequired: null,
    close: null,
  },
  service: {
    submitted: null,
    inProgress: null,
  },
  incident: {
    incidentDetected: null,
    inProgress: null,
    close: null,
    resolved: null,
    restored: null,
  },
  change: {
    submitted: null,
    customerApprovalRequired: null,
    awaitingDcApproval: null,
    accepted: null,
    closed: null,
    declined: null,
    cancelled: null,
    completed: null,
    partiallyCompleted: null,
  },
  notification: {
    maintenance: null,
    access: null,
    service: null,
    incident: null,
    change: null,
  },
};

const setStatusLoading = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    isLoading: payload,
  };
};

const setStatuses = (state, { payload }) => ({
  ...state,
  [ACCESS]: {
    submitted: payload.access.submitted,
    accepted: payload.access.accepted,
    customerApprovalRequired: payload.access.customer_approval_required,
    approvalReceived: payload.access.customer_approval_received,
    declined: payload.access.declined,
    cancelled: payload.access.cancelled,
    closed: payload.access.closed,
  },
  [ACCESS_SECURITY]: {
    submitted: payload.access.submitted,
    accepted: payload.access.accepted,
    customerApprovalRequired: payload.access.customer_approval_required,
    closed: payload.access.closed,
  },
  [SERVICE]: {
    submitted: payload.service.submitted,
    accepted: payload.service.accepted,
    approvalReceived: payload.service.customer_approval_received,
  },
  [INCIDENT]: {
    incidentDetected: payload.incident.incident_detected,
    inProgress: payload.incident.in_progress,
    closed: payload.incident.closed,
    resolved: payload.incident.resolved,
    restored: payload.incident.restored,
  },
  [CHANGE]: {
    submitted: payload.change.submitted,
    awaitingDcApproval: payload.change.awaiting_dc_approval,
    customerApprovalRequired: payload.change.customer_approval_required,
    approvalReceived: payload.change.customer_approval_received,
    accepted: payload.change.accepted,
    closed: payload.change.closed,
    declined: payload.change.declined,
    cancelled: payload.change.cancelled,
    completed: payload.change.completed,
    partiallyCompleted: payload.change.partiallyCompleted,
  },
  [NOTIFICATION]: {
    maintenance: payload.notification.maintenance,
    access: payload.notification.access,
    service: payload.notification.service,
    incident: payload.notification.incident,
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STATUSES_LOADING: {
      return setStatusLoading(state, action);
    }
    case SET_STATUSES: {
      return setStatuses(state, action);
    }
    default:
      return state;
  }
};
